import { E2EHelper } from "../core/e2e-helper";
import { ResultLevel } from "../checkresultdialog/checkresultdata";

declare const logEnabled: any;

/* eslint-disable no-console */
/* tslint:disable */

export class Logger {
	public static isEnabled = (): boolean => {
		return (typeof logEnabled !== "undefined")
			&& (typeof console !== "undefined")
			&& logEnabled != null
			&& console != null;
	}

	public static log = (...args: any[]) => Logger.process("log", false, args);

	public static logWithTrace = (...args: any[]) => Logger.process("log", true, args);

	public static warn = (...args: any[]) => Logger.process("warn", false, args);

	public static warnWithTrace = (...args: any[]) => Logger.process("warn", true, args);

	public static error = (...args: any[]) => Logger.process("error", false, args);

	public static errorWithTrace = (...args: any[]) => Logger.process("error", true, args);

	public static table = (...args: any[]) => Logger.process("table", false, args);

	public static beginGroup = (name?: string) => Logger.process("group", false, [name]);

	public static beginGroupCollapsed = (name?: string) => Logger.process("groupCollapsed", false, [name]);

	public static endGroup = () => Logger.process("groupEnd", false, []);

	public static assert = (condition: () => any, ...args: any[]) => {
		if (!Logger.isEnabled()) {
			return;
		}

		try {
			let flag = condition();
			if (!flag) {
				Logger.errorWithTrace("Assertion Error:", condition, ...args);
			}
		} catch (e) {
			Logger.errorWithTrace("Exception encountered while evaluating assert condition:", e, condition, ...args);
			return;
		}
	}

	private static process(logFn: "log" | "warn" | "error" | "table" | "groupCollapsed" | "group" | "groupEnd", useStackTrace: boolean, args: any[]) {
		if (!Logger.isEnabled()) {
			return;
		}

		switch (logFn) {
			case "groupCollapsed":
				console.groupCollapsed(args[0]);
				break;

			case "group":
				console.group(args[0]);
				break;

			case "groupEnd":
				console.groupEnd();
				break;

			default:
				for (let item of args) {
					console[logFn](item);
				}
				break;
		}

		if (logFn === "table") {
			console.log(args[0]);
		}

		if (useStackTrace) {
			console.groupCollapsed("Stack Trace");
			console.trace();
			console.groupEnd();
		}

		let severity: ResultLevel;
		switch (logFn) {
			case "group":
			case "groupCollapsed":
			case "log":
				severity = ResultLevel.Info;
				break;
			case "warn":
				severity = ResultLevel.Warning;
				break;
			case "error":
				severity = ResultLevel.Error;
				break;
			default:
				severity = null;
				break;
		}

		if (severity) {
			E2EHelper.getInstance().trigger({ source: "console", message: args, severity });
		}
	}
}